<template>

  <div class="text-center grey lighten-5" style="padding-top:100px">
      <div v-role="'est'" class="text-center">

    <h2 style="text-align:Center;">Menu Estatística </h2><br>
  </div>
    <v-row>
      <v-col cols="12" md="3">
        </v-col>
      <v-col cols="12" md="2">
    <!-- Menu Estudante -->
    <v-menu
      v-model="menuEstudante"
      :close-on-content-click="false"
      :nudge-width="200"
      offset-x
    >
      <template v-slot:activator="{ on }">
       <v-btn class="mx-2" fab dark x-large color="primary" v-on="on">
         <v-icon dark>people</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-list>
          <v-list-item>

            <v-list-item-content>
              <v-list-item-title>Estudantes</v-list-item-title>
              <v-list-item-subtitle>{{instituicaodescricao}}</v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action>
              <v-btn
                :class="fav ? 'red--text' : ''"
                icon
                @click="fav = !fav"
              >
                <v-icon>mdi-heart</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-list>
           <!-- Classe -->
          <v-list-item>
            <v-list-item-action>
              <v-btn class="mx-2" fab dark small color="pink" @click="$router.push('aluno-classe-estatistica')"> <v-icon dark>view_headline</v-icon></v-btn>
            </v-list-item-action>
            <v-list-item-title>Classe</v-list-item-title>
          </v-list-item>
               <!-- Fim Classe -->

                <!-- Curso -->
          <v-list-item>
            <v-list-item-action>
            <v-btn class="mx-2" fab dark small color="pink" @click="$router.push('aluno-curso')">
      <v-icon dark>school</v-icon>
    </v-btn>
            </v-list-item-action>
            <v-list-item-title>Curso</v-list-item-title>
          </v-list-item>
           <!-- Fim Curso -->

                    <!-- Ano Lectivo -->
          <v-list-item>
            <v-list-item-action>
             <v-btn class="mx-2" fab dark  small color="indigo" @click="$router.push('aluno-anoLectivo')">
      <v-icon dark>event_note</v-icon>
    </v-btn>
            </v-list-item-action>
            <v-list-item-title>Ano Lectivo</v-list-item-title>
          </v-list-item>
                 <!-- Fim Ano Lectivo -->

                  <!-- Turma -->
          <v-list-item>
            <v-list-item-action>
             <v-btn class="mx-2" fab dark small color="teal" @click="$router.push('aluno-turma')">
      <v-icon dark>people_outline</v-icon>
    </v-btn>
            </v-list-item-action>
            <v-list-item-title>Turma</v-list-item-title>
          </v-list-item>
                 <!-- Fim Turma -->

                  <!-- Genêro -->
          <v-list-item>
            <v-list-item-action>
            <v-btn class="mx-2" fab dark small color="cyan" @click="$router.push('aluno-sexo')">
      <v-icon dark>wc</v-icon>
    </v-btn>
            </v-list-item-action>
            <v-list-item-title>Genêro</v-list-item-title>
          </v-list-item>
                 <!-- Fim Genêro -->
        </v-list>
      </v-card>
    </v-menu>
    <br>
    Estudantes
    </v-col>
    <!--Fim Menu Estudante -->

<!-- Menu Professor -->
<v-col cols="12" md="2">
     <v-menu
      v-model="menuProfessor"
      :close-on-content-click="false"
      :nudge-width="200"
      offset-x
    >
      <template v-slot:activator="{ on }">
       <v-btn class="mx-2" fab dark x-large color="indigo" v-on="on">
         <v-icon dark>person</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-list>
          <v-list-item>

            <v-list-item-content>
              <v-list-item-title>Professores</v-list-item-title>
              <v-list-item-subtitle>{{instituicaodescricao}}</v-list-item-subtitle>
            </v-list-item-content>

          </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-list>
           <!-- Classe -->
          <v-list-item>
            <v-list-item-action>
              <v-btn class="mx-2" fab dark small color="pink" @click="$router.push('professor-classe-estatistica')"> <v-icon dark>view_headline</v-icon></v-btn>
            </v-list-item-action>
            <v-list-item-title>Classe</v-list-item-title>
          </v-list-item>
               <!-- Fim Classe -->

                <!-- Curso -->
          <v-list-item>
            <v-list-item-action>
            <v-btn class="mx-2" fab dark small color="pink" @click="$router.push('professor-curso')">
      <v-icon dark>school</v-icon>
    </v-btn>
            </v-list-item-action>
            <v-list-item-title>Curso</v-list-item-title>
          </v-list-item>
           <!-- Fim Curso -->

                    <!-- Ano Lectivo -->
          <v-list-item>
            <v-list-item-action>
             <v-btn class="mx-2" fab dark  small color="indigo" @click="$router.push('professor-anoLectivo')">
      <v-icon dark>event_note</v-icon>
    </v-btn>
            </v-list-item-action>
            <v-list-item-title>Ano Lectivo</v-list-item-title>
          </v-list-item>
                 <!-- Fim Ano Lectivo -->

                  <!-- Turma -->
          <v-list-item>
            <v-list-item-action>
             <v-btn class="mx-2" fab dark small color="teal" @click="$router.push('professor-turma')">
      <v-icon dark>people_outline</v-icon>
    </v-btn>
            </v-list-item-action>
            <v-list-item-title>Turma</v-list-item-title>
          </v-list-item>
                 <!-- Fim Turma -->
        </v-list>
      </v-card>
    </v-menu><br>
    Professores
    </v-col>
    <!--Fim menu Professor -->

<!-- menu turmas  -->
<v-col cols="12" md="2">
     <v-menu
      v-model="menuTurmas"
      :close-on-content-click="false"
      :nudge-width="200"
      offset-x
    >
      <template v-slot:activator="{ on }">
       <v-btn class="mx-2" fab dark x-large color="teal" v-on="on">
         <v-icon dark>home_work</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-list>
          <v-list-item>

            <v-list-item-content>
              <v-list-item-title>Turmas</v-list-item-title>
              <v-list-item-subtitle>{{instituicaodescricao}}</v-list-item-subtitle>
            </v-list-item-content>

          </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-list>
           <!-- Classe -->
          <v-list-item>
            <v-list-item-action>
              <v-btn class="mx-2" fab dark small color="cyan" @click="$router.push('quantidade-turmas')">
      <v-icon dark>account_balance</v-icon>
    </v-btn>
            </v-list-item-action>
            <v-list-item-title>Turmas</v-list-item-title>
          </v-list-item>
               <!-- Fim Classe -->
        </v-list>
      </v-card>
    </v-menu><br>
    Turmas
    </v-col>
    </v-row>
    <!--Fim menu Turmas -->
    <div style="padding-top:200px"></div>
  </div>
</template>

<script>
const ls = require('local-storage')
export default {
  data: () => ({
    instituicaodescricao: ls.get('instituicaodescricao'),
    fav: true,
    menuEstudante: false,
    menuProfessor: false,
    menuTurmas: false,
    message: false,
    hints: true
  })
}
</script>
